/* eslint-disable no-undef */
export const environment = {
  apiUrl: process.env.REACT_APP_API_URL || '',
  clientId: process.env.REACT_APP_CLIENT_ID || '',
  clientScopes: process.env.REACT_APP_API_SCOPE || '',
  useMock: process.env.REACT_APP_USE_MOCK_API || '',
  appInsightsKey: process.env.REACT_APP_APPINSIGHTS_KEY || '',
  bingmapKey: process.env.REACT_APP_BINGMAP_URL_KEY || '',
  sendToGenoaIsDevelopment: process.env.REACT_APP_SENDTOGENOA_ISDEVELOPMENT || '',
  customCssBaseUrl: process.env.REACT_APP_CUSTOM_CSS || ''
};
